/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

import * as packageLock from '../package-lock.json';

// Disable console logs in production environment
if (environment.production) {
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.debug = () => {};
}

// [TEMPORARY REVIEW PROCESS] Mapeo de variables de entorno y de package-lock.json (Dinámico)
console.log('=== [REVISIÓN] VARIABLES DE ENTORNO ===');
console.log('Environment:', environment);
console.log('=== [REVISIÓN] VARIABLES DE PACKAGE-LOCK.JSON ===');

// Extraer sólo los metadatos principales del archivo dinámico para mantener la consola legible
const rootPackageVars = (packageLock as any).packages ? (packageLock as any).packages[""] : null;

console.log('Package Variables:', {
  name: (packageLock as any).name,
  version: (packageLock as any).version,
  lockfileVersion: (packageLock as any).lockfileVersion,
  requires: (packageLock as any).requires,
  packages: {
    "": rootPackageVars
  }
});
console.log('=======================================');


console.log('Bootstrapping application with appConfig:', appConfig);

bootstrapApplication(App, appConfig).catch((err: unknown) =>
  console.error('Bootstrap error:', err),
);
